  //export const urlServeur ="https://makutu.site/ci_cicd_intra/index.php"
 const urlServeurProc = () => {
    let urlx = window.location.href;
    if (urlx.indexOf('makutu', 1) !=-1 ) {
        return "https://makutu.site/"
    } else {
        return "http://localhost:8888/"
    }

 }

export const urlServeur = urlServeurProc()+"ci_cicd_intra/index.php";

export const pathImages = "https://makutu.site/ci_cicd_intra/assets/images/"
export const tabcouleur = {
    "Programmeur": "04A2FC",
    "chef de projet": "04A2FC",
    "Chef de projet": "04A2FC",
    "Formateur": "EACD13",
    "Formateur/commercial": "EACD13",
    "Chargée d\'affaire": "88CA0C",
    "Secrétaire de direction - ass.": "CD8FEC",
    "Standardiste - Ass. administrative": "CD8FEC",
    "Entretien": "5BD8F7",
    "Responsable sécurité" : 'FA5727'

  };
export const tabCouleurAugmentation = {
    0: "",
    1: '#B3F383',
    2: '#78BD45',
    3: '#508E23',
    4:'#B64EEE'
}

